import { render, staticRenderFns } from "./AntViewLoading.vue?vue&type=template&id=5fb0a448&scoped=true"
import script from "./AntViewLoading.vue?vue&type=script&lang=js"
export * from "./AntViewLoading.vue?vue&type=script&lang=js"
import style0 from "./AntViewLoading.vue?vue&type=style&index=0&id=5fb0a448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb0a448",
  null
  
)

export default component.exports